import type {
  AncillariesProduct,
  CabinBagsSelection,
  GetShoppingSummaryItineraryQuery,
} from '@/generated/graphql';

interface AncilliariesProductData {
  cabinBagsSelections: Array<CabinBagsSelection>;
}

const ANCILLARIES_PRODUCT = 'AncillariesProduct';

export const filterProductDataByAncilliaries = (
  data:
    | GetShoppingSummaryItineraryQuery['getShoppingSummary']['products']
    | undefined
): AncilliariesProductData => {
  const ancillaries = data?.find(
    (product) => product.__typename === ANCILLARIES_PRODUCT
  ) as AncillariesProduct;

  const cabinBagsSelections =
    ancillaries?.productInfo?.cabinBagsSelections ?? [];

  return {
    cabinBagsSelections,
    // Add more fields as needed from the AncillariesProduct
  };
};
